export function telHref(phone) {
  const digits = String(phone || "").replace(/[^\d+]/g, "");
  if (!digits) return "";
  if (digits.startsWith("+")) return `tel:${digits}`;
  if (digits.startsWith("00")) return `tel:+${digits.slice(2)}`;
  return `tel:+39${digits}`;
}

export function waHref(phone, message) {
  const tel = telHref(phone).replace("tel:+", "");
  if (!tel) return "";
  return `https://wa.me/${tel}${message ? `?text=${encodeURIComponent(message)}` : ""}`;
}

export function getLinks(settings) {
  const l = settings?.links || {};
  return {
    instagram: l.instagram_enabled !== false ? l.instagram_url : "",
    tiktok: l.tiktok_enabled !== false ? l.tiktok_url : "",
    phone: l.phone_enabled !== false ? l.phone_number : "",
    review: l.google_review_enabled !== false ? l.google_review_url : "",
    whatsapp: l.whatsapp_enabled !== false ? waHref(l.whatsapp_number, l.whatsapp_message) : "",
  };
}
